import BaseApi from '../base/apiBase.service'

export default class DriverService extends BaseApi {
  constructor (args) {
    super(args)

    this.service_uri = {
      get: '/drive/driver',
      create: '/drive/driver/',
      update: '/drive/driver/'
    }
  }

  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async update(data) {
    return super.update(data);
  }

  async create(data) {
    return super.create(data);
  }
}